<template>
  <div>
        <section class="eventdetail" v-if="!hasEditing">
<!-- {{eachEventInfo}} -->
    <div class="meetup-header mb-8">
        <div class="meetup_inner_holder">
          <div class="meetup-day">
            <h6 class="mb-0">
              {{ $moment(eachEventInfo.start,'DD/MM/YYYY').format("MMMM") }}
            </h6>
            <h3 class="mb-0">{{ $moment(eachEventInfo.start,'DD/MM/YYYY').format("D") }}</h3>
          </div>
          <div class="my-auto w-full">
            <!-- <div class="flex flex-wrap items-center">
              <h4 class="card-title mb-25">{{ eachEventInfo.title }}</h4> -->
              <!-- <span
                class="cstm-status-badge"
                :class="
                  getCourseTypeName(
                    eachEventInfo.extendedProps.course.course.course_setting
                      .course_type
                  ).toLowerCase()
                "
              >
                {{
                  getCourseTypeName(
                    eachEventInfo.extendedProps.course.course.course_setting
                      .course_type
                  )
                }}
              </span> -->
            <!-- </div> -->

            <div class="flex flex-wrap items-center my-2">
              <div class="sm:w-1/2 w-full my-2">
                <div class="flex items-center my-2 mr-3">
                  <div class="badge-avatar">
                    <span class="material-icons-outlined">school</span>
                  </div>
                  <div class="ml-2">
                    <h6 style="font-size: 12px;">Class Name:</h6>
                    <p class="card-text mb-0 ml-1">
                      {{ eachEventInfo.title }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="sm:w-1/2 w-full my-2">
                <div class="flex items-center my-2 mr-3">
                  <div class="badge-avatar">
                    <span class="material-icons-outlined">local_library</span>
                  </div>
                  <div class="ml-2">
                    <h6 style="font-size: 12px;">Teacher Name:</h6>
                    <p class="card-text mb-0 ml-1">
                      {{ eachEventInfo.extendedProps.class.teacher.first_name }}
                      {{ eachEventInfo.extendedProps.class.teacher.middle_name }}
                      {{ eachEventInfo.extendedProps.class.teacher.last_name }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="sm:w-1/2 w-full my-2">
                <div class="flex items-center my-2 mr-3">
                  <div class="badge-avatar">
                    <span class="material-icons-outlined">pending_actions</span>
                  </div>
                  <div class="ml-2">
                    <h6 style="font-size: 12px;">Session Name:</h6>
                    <p class="card-text mb-0 ml-1">
                      {{ eachEventInfo.extendedProps.class.class.term }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="sm:w-1/2 w-full my-2">
                <div class="flex items-center mr-3">
                  <div class="badge-avatar">
                    <span class="material-icons-outlined">sticky_note_2</span>
                  </div>
                  <div class="ml-2">
                    <h6 style="font-size: 12px;">Subject Name:</h6>
                    <p class="card-text mb-0 ml-1">
                      {{ eachEventInfo.extendedProps.class.subject_name }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="editable_holder">
          <vs-button
            radius
            icon="edit"
            color="primary"
            vs-type="flex"
           
          />
        </div> -->
      </div>
    
    
      <div class="flex flex-wrap items-center">
        <div class="inform-meetup-holder sm:w-1/2 w-full sm:pr-2 pr-0 my-2">
          <div class="badge-avatar">
            <span class="material-icons">date_range</span>
          </div>
          <div>
            <h6 style="font-size: 12px;">Session Duration</h6>
              <p>
                {{
                  $moment(
                    eachEventInfo.extendedProps.class.class.start_date
                  ).format('DD/MM/YYYY')
                }}
                -
                {{
                  $moment(
                    eachEventInfo.extendedProps.class.class.end_date
                  ).format('DD/MM/YYYY')
                }}
              </p>
          </div>
        </div>
        <div class="inform-meetup-holder sm:w-1/2 w-full sm:pr-2 pr-0 my-2">
          <div class="badge-avatar">
            <span class="material-icons-outlined">schedule</span>
          </div>
          <div>
            <h6 style="font-size: 12px;">Period timing</h6>
            <!-- <small>{{ $moment.format(eachEventInfo.extendedProps.course.schedule_from_time, 'HH:mm') }} - {{ eachEventInfo.extendedProps.course.schedule_to_time }}</small> -->
            <p
              >{{
                eachEventInfo.extendedProps.class.schedule_from_time.slice(0, -3)
              }}
              -
              {{
                eachEventInfo.extendedProps.class.schedule_to_time.slice(0, -3)
              }}</p
            >
          </div>
        </div>
      </div>
        <!-- <div class="flex flex-wrap items-center">

            <div
              class="status_main_holder"
              :class="{ active: iconSkypeActive }"
              @click="icon('skype')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                height="28px"
                style="enable-background: new 0 0 512 512"
                version="1.1"
                viewBox="0 0 512 512"
                width="28px"
                xml:space="preserve"
              >
                <g id="_x34_1-skype_x2C__chat">
                  <g>
                    <g>
                      <path
                        d="M486.129,258.485c0-124.26-101.885-225.02-227.592-225.02c-13.244,0-26.246,1.139-38.926,3.289     c-20.34-12.646-44.409-20.004-70.21-20.004c-72.918,0-132.004,58.406-132.004,130.509c0,24.079,6.624,46.592,18.136,66.004     c-3.014,14.593-4.621,29.758-4.621,45.222c0,124.289,101.905,225.042,227.592,225.042c14.26,0,28.158-1.322,41.695-3.769     c18.613,9.866,39.814,15.491,62.428,15.491c72.891,0,131.977-58.44,131.977-130.486c0-20.813-4.949-40.486-13.721-57.955     C484.344,291.199,486.129,275.077,486.129,258.485L486.129,258.485z M486.129,258.485"
                        style="fill: #03acf8"
                      />
                      <path
                        d="M375.275,366.021c-10.533,14.742-26.068,26.409-46.262,34.662     c-19.957,8.196-43.848,12.413-71.105,12.413c-32.691,0-60.1-5.682-81.511-16.927c-15.304-8.169-27.886-19.202-37.463-32.896     c-9.693-13.76-14.555-27.426-14.555-40.674c0-8.194,3.192-15.371,9.488-21.206c6.234-5.83,14.226-8.727,23.771-8.727     c7.809,0,14.55,2.299,20.039,6.875c5.221,4.429,9.725,10.945,13.336,19.29c4.021,9.149,8.408,16.865,13.031,22.874     c4.504,5.893,10.918,10.801,19.115,14.659c8.264,3.828,19.387,5.831,33.051,5.831c18.816,0,34.266-4.008,45.84-11.813     c11.363-7.628,16.85-16.839,16.85-28.084c0-8.856-2.891-15.848-8.764-21.323c-6.211-5.742-14.381-10.195-24.283-13.276     c-10.348-3.173-24.396-6.642-41.754-10.23c-23.65-4.993-43.725-10.881-59.65-17.641c-16.317-6.881-29.498-16.392-39.102-28.261     c-9.783-12.141-14.732-27.309-14.732-45.131c0-16.982,5.188-32.296,15.449-45.516c10.168-13.125,25.022-23.386,44.204-30.357     c18.877-6.904,41.334-10.373,66.773-10.373c20.311,0,38.18,2.33,53.119,6.936c15.004,4.604,27.646,10.825,37.584,18.514     c10.021,7.774,17.475,15.996,22.125,24.609c4.717,8.676,7.135,17.321,7.135,25.658c0,8.045-3.131,15.375-9.344,21.713     c-6.262,6.405-14.131,9.629-23.381,9.629c-8.408,0-15.031-2.063-19.592-6.038c-4.262-3.739-8.711-9.572-13.604-17.882     c-5.664-10.651-12.555-19.052-20.43-25.006c-7.662-5.77-20.428-8.643-38.023-8.643c-16.285,0-29.588,3.235-39.432,9.633     c-9.482,6.126-14.104,13.186-14.104,21.558c0,5.119,1.49,9.394,4.559,13.07c3.223,3.945,7.787,7.33,13.57,10.197     c5.969,2.965,12.143,5.354,18.314,7.028c6.322,1.734,16.914,4.337,31.496,7.659c18.432,3.886,35.342,8.284,50.314,13.036     c15.18,4.753,28.248,10.645,38.982,17.555c10.885,7.026,19.506,15.998,25.65,26.766c6.141,10.857,9.248,24.163,9.248,39.655     C391.197,334.351,385.83,351.25,375.275,366.021L375.275,366.021z M375.275,366.021"
                        style="fill: #fcfcfc"
                      />
                    </g>
                  </g>
                </g>
                <g id="Layer_1" />
              </svg>
              <div class="status_icon_holder">
                <span v-if="skype_url" class="material-icons-outlined check"
                  >check_circle</span
                >
                <span v-else class="material-icons-outlined error"
                  >error_outline</span
                >
              </div>
            </div>

            <div
              class="status_main_holder"
              :class="{ active: iconZoomActive }"
              @click="icon('zoom')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
                  fill="#2D8CFF"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M38.087 15.9353L31.3043 20.884V27.135L38.087 32.0837C38.5669 32.4503 39.1304 32.5636 39.1304 31.5628V16.4562C39.1304 15.5638 38.6782 15.4517 38.087 15.9353ZM8.34782 27.7567V16.4873C8.34782 16.0263 8.72491 15.6522 9.19007 15.6522H25.6254C28.1845 15.6522 30.2609 17.7077 30.2609 20.2433V31.5127C30.2609 31.9737 29.8838 32.3478 29.4186 32.3478H12.9833C10.4242 32.3478 8.34782 30.2923 8.34782 27.7567Z"
                  fill="white"
                />
              </svg>
              <div class="status_icon_holder">
                <span v-if="zoom_url" class="material-icons-outlined check"
                  >check_circle</span
                >
                <span v-else class="material-icons-outlined error"
                  >error_outline</span
                >
              </div>
            </div>
          </div>
          <vs-input
            disabled
            v-if="skype"
            v-model="skype_url"
            class="custom_Input my-2"
            style="width: 100%"
            placeholder="Enter Skype Link"
          />
          <vs-input
          disabled
            v-if="zoom"
            v-model="zoom_url"
            class="custom_Input my-2"
            style="width: 100%"
            placeholder="Enter Zoom Link"
          />
      <vs-button
            icon="edit"
            color="primary"
            @click="hasEditing = true"
            v-if="checkingEdit  && eachEventInfo.extendedProps.course.course.course_setting.course_class_type.includes('one_2_one')"

            >Reschedule</vs-button
          > -->
  </section>
  <!-- <section v-else>
     <editing-reschedule-component
        :eachEventInfo="eachEventInfo"
        :schedule_date="eachEventInfo.extendedProps.course.schedule_date"
        :start_time="eachEventInfo.extendedProps.course.schedule_from_time"
        :end_time="eachEventInfo.extendedProps.course.schedule_to_time"
        :userId="eachEventInfo.extendedProps.userId"
        :color_code="eachEventInfo.extendedProps.course.colour_code"
        :schedule_id="eachEventInfo.extendedProps.course.schedule_id"
        :course_id="eachEventInfo.extendedProps.course.course.id"
        :client_user_id="eachEventInfo.extendedProps.course.clients[0].client_user_id"
        @updateReschedule="updateRescheduleEmit"
                @cancelEditingComponent="cancelEditingComponent"

      >
      </editing-reschedule-component>

  </section> -->
  </div>
</template>

<script>
import EditingRescheduleComponent from './EditingRescheduleComponent'

export default {
  components:{
    EditingRescheduleComponent
  },
  data () {
    return {
      hasEditing:false,
      datedifference: 0,
      skype: false,
      zoom: false,
      iconSkypeActive: false,
      iconZoomActive: false,
      skype_url: '',
      zoom_url: ''

    }
  },
  props: {
    eachEventInfo: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.datedifference = this.validateTodayDate(
      new Date(),
      this.eachEventInfo.start
    )
    //this.skype_url = this.eachEventInfo.extendedProps.course.skype_link
    //this.zoom_url = this.eachEventInfo.extendedProps.course.zoom_link
    //
  },
  computed:{
    checkingEdit () {
      return (
        this.eachEventInfo.extendedProps.course.course.course_setting
          .reschedule_allowed &&
        !this.hasEditing &&
        this.datedifference < 0
        && this.eachEventInfo.extendedProps.course.already_reschedule_count < this.eachEventInfo.extendedProps.course.course_setting.reschedule_count
      )
    }
  },
  methods:{
    icon (type) {
      if (type === 'skype') {
        this.skype = true
        this.zoom = false
        this.iconSkypeActive = true
        this.iconZoomActive = false
      } else {
        this.skype = false
        this.zoom = true
        this.iconSkypeActive = false
        this.iconZoomActive = true
      }
    },
    updateRescheduleEmit (updatedObject) {
      this.$emit('editedSchedule', updatedObject)
      // this.hasEditing = true
    },
    cancelEditingComponent () {
      this.hasEditing = false
    },
    getCourseTypeName (typeId) {
      let courseTypeName = ''
      switch (typeId) {
      case 1:
        courseTypeName = 'Open'
        break
      case 2:
        courseTypeName = 'Free'
        break
      case 3:
        courseTypeName = 'Paid'
        break
      case 4:
        courseTypeName = 'Recurring'
        break
      default:
        courseTypeName = 'Others'
      }
      return courseTypeName
    }
  }
}
</script>

<style>
.color-holder {
  width: 100%;
  height: 30px;
  border-radius: 5px;
}
.vs-tooltip {
  z-index: 100000;
}
.meetup-header {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
}
.meetup_inner_holder {
  width: calc(100% - 38px);
  display: flex;
  /* flex-wrap: wrap; */
}
.editable_holder {
  position: absolute;
  top: 0;
  right: 0;
}
.meetup-header .meetup-day {
  border-right: 1px solid #d8d6de;
  padding-right: 1.3rem;
  margin-right: 1.3rem;
  text-align: center;
}
.meetup-header .card-title {
  font-weight: 500;
  font-size: 1.285rem;
  display: inline-block;
}
.inform-meetup-holder {
  display: flex;
  align-items: center;
  margin: 20px 0;
}
.inform-meetup-holder .badge-avatar {
  margin-right: 14px;
}
.status_main_holder {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(65, 207, 221, 0.12);
  border-radius: 5px;
  margin: 0 15px 10px 0;
  cursor: pointer;
}
.status_main_holder.active {
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.2);
  transform: scale(1.12);
}
.status_main_holder .status_icon_holder {
  position: absolute;
  top: -8px;
  right: -8px;
}
.status_main_holder .status_icon_holder .check {
  color: rgba(var(--vs-success), 1);
  font-size: 20px;
}
.status_main_holder .status_icon_holder .error {
  color: rgba(var(--vs-warning), 1);
  font-size: 20px;
}
</style>